import React, { useState } from 'react'
import styled from 'styled-components'
import ContentArea from '../components/ContentArea'
import SelectButton from '../components/SelectButton'
import ButtonComponent from '../components/ButtonComponent'
import ReactGA from 'react-ga'

const MeditatePage = () => {
  const HomeHeader = styled.h1`
    font-weight: 500;
    width: 70%;
    margin: 0 auto 53pt !important;
    text-align: center;
    font-size: 20pt;

    @media screen and (min-width: 768px) {
      margin-bottom: 3rem !important;
    }
  `
  const [isHidden, setIsHidden] = useState(true)
  const [isSelected, setIsSelected] = useState(false)
  const [minutes, setMinutes] = useState('')

  const selectMinutes = (e) => {
    e.preventDefault()
    setMinutes(e.target.innerHTML.split(' ')[0])
    setIsHidden(!isHidden)
    setIsSelected(true)
  }
  const hideElements = () => {
    setIsHidden(!isHidden)
  }

  return (
    <ContentArea transparent shadowless fullsize>
      {isHidden && !isSelected && (
        <div>
          <div>
            <HomeHeader>Mindfulness Practice </HomeHeader>
            <ButtonComponent text="Introduction" link="/meditate/introduction" />
            <SelectButton value={"Guided Meditation"} onclick={hideElements} />
          </div>
        </div>
      )}
      {!isHidden && (
        <div>
          <div>
            <HomeHeader>How long would you like to meditate? </HomeHeader>
            <SelectButton value={5} minutes onclick={selectMinutes} />
            <SelectButton value={10} minutes onclick={selectMinutes} />
            <SelectButton value={15} minutes onclick={selectMinutes} />
            <SelectButton value={25} minutes onclick={selectMinutes} last />
          </div>
        </div>
      )}
      {isHidden && isSelected && (
        <div>
          <div>
            <HomeHeader>
              {minutes} minutes
            <br />
            Choose one of the followings:
          </HomeHeader>
            <SelectButton
              value="Body Scan"
              link
              linkto={`/player/bodyscan/${minutes}`}
              onclick={
                ReactGA.event({
                  category: 'Guided Meditations',
                  action: 'Body Scan',
                  label: `${minutes} minutes`
                })
              }
            />
            <SelectButton
              value="Breath Awareness"
              link
              linkto={`/player/breathawareness/${minutes}`}
              last
              onclick={
                ReactGA.event({
                  category: 'Guided Meditations',
                  action: 'Breath Awareness',
                  label: `${minutes} minutes`
                })
              }
            />
          </div>
        </div>
      )}

    </ContentArea>
  )
}

export default MeditatePage
